import { observable, action, runInAction } from 'mobx'
import Api from '@api/marketing'

class Store {
  @observable standard_price = {}
  @observable flagship_price = {}
  @observable standard_to_flagship = {}

  @action
  getData = async () => {
    const { data } = await Api.getShopProductPrice()
    runInAction(() => {
      this.standard_price = data.standard
      this.flagship_price = data.flagship
      this.standard_to_flagship = data.standard_to_flagship
    })
  }

  // @action
  // getBuyInfo = async () => {
  //   const { data } = await Api.getBuyInfo()
  //   console.log(data)
  // }
}

export default Store
